import { render, staticRenderFns } from "./ClickableText.vue?vue&type=template&id=eae95406&scoped=true&"
import script from "./ClickableText.vue?vue&type=script&lang=js&"
export * from "./ClickableText.vue?vue&type=script&lang=js&"
import style0 from "./ClickableText.vue?vue&type=style&index=0&id=eae95406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae95406",
  null
  
)

export default component.exports